<ion-content class="contacts">
  <ng-container>
    <app-header [title]="(routeStopName ?? '') + ' (' + stopName + ') : Customer'" [breadcrumbs]="breadcrumbs"></app-header>
    <ion-grid style=" padding-top:120px">
      <div class="div-container">
        <ion-row>
          <ion-header>Customer AR Status</ion-header>
        </ion-row>
        <ion-row >
          <div >
            <div *ngIf="customer">
              
            <p><strong>Customer Name:</strong> {{ customer.name }}</p> 
            <p><strong>A/R Status as of:</strong> {{ customer.statusDate | date:'MM/dd/yy hh:mm a'  }}</p>
             <p><strong>Current Balance Due:</strong> {{ customer.currBal | currency }}</p> 
            <p [ngClass]="{ 'period': isClassActive(1) }"><strong>01-30 Days Past Due:</strong> {{ customer.period1 | currency }}</p>
            <p [ngClass]="{ 'period': isClassActive(2) }"><strong>31-60 Days Past Due:</strong> {{ customer.period2 | currency }}</p>
            <p [ngClass]="{ 'period': isClassActive(3) }"><strong>61-90 Days Past Due:</strong> {{ customer.period3 | currency }}</p>
            <p [ngClass]="{ 'period': isClassActive(4) }"><strong>90+ Days Past Due:</strong> {{ customer.period4 | currency }}</p>
            <p *ngIf="totalBalance"><strong>Total Balance:</strong> {{ totalBalance | currency }}</p> 
          </div>
          </div>
        </ion-row>

       
        
       
      </div>
    </ion-grid>
  </ng-container>
</ion-content>
